// extracted by mini-css-extract-plugin
export default {"root":"Home_root__hJun4","centered":"Home_centered__KHn6F","logo":"Home_logo__jnuVc","button":"Home_button__IrNH7","header":"Home_header__zTf-H"};